import { Link } from 'react-router-dom';
import {
  coverPhoto,
  formatPrice,
  formatMoney,
  getPreviousPrice,
  isHighDemand,
  listingFreshnessBadge,
  listingFreshnessLabel,
} from '../lib/format';
import { formatDistance } from '../lib/geo';
import Icon from './Icon';

export default function ListingCard({ item, asDiv = false }) {
  const cover = coverPhoto(item);
  const miles = item._distance;
  const prev = getPreviousPrice(item);
  const freshness = listingFreshnessBadge(item);
  const locationLabel =
    miles != null
      ? formatDistance(miles)
      : item.pickup?.label || item.pickup?.city || 'Nearby';

  const body = (
    <>
      <div className="listing-image">
        {cover ? (
          <img src={cover} alt="" loading="lazy" />
        ) : (
          <div className="image-fallback">
            <Icon name="camera" size={28} />
          </div>
        )}
        <div className="listing-badges">
          {freshness && (
            <span className={`badge badge-${freshness.replaceAll('_', '-')}`}>
              {listingFreshnessLabel(freshness)}
            </span>
          )}
          {isHighDemand(item) && (
            <span className="badge badge-demand">High demand</span>
          )}
          {item.supportsShipping && <span className="badge badge-ship">Ships</span>}
          {item.isFree === true && <span className="badge badge-free">Free</span>}
        </div>
      </div>
      <div className="listing-copy">
        <p className="listing-title">{item.title}</p>
        <p className="listing-price">
          {prev != null && (
            <span className="old-price">{formatMoney(prev, item.currency)}</span>
          )}
          <span>{formatPrice(item)}</span>
        </p>
        <p className="listing-meta">
          <Icon name={miles != null && miles < 3 ? 'walk' : 'car'} size={13} />
          {locationLabel}
        </p>
      </div>
    </>
  );

  if (asDiv) return <div className="listing-card">{body}</div>;
  return (
    <Link to={`/listing/${item.id}`} className="listing-card">
      {body}
    </Link>
  );
}
